(function (scope) {
	scope.Carousel = function (owlCarouselContainerEl) {
		var me = this;
		var owlCarouselContainer = $(owlCarouselContainerEl);
		me.init = function () {
			me.initResize ();
			me.loadCarousels ();
		};
		me._resizeTimeout;
		me.initResize = function () {
			$(window).on ("resize", function () {
				clearTimeout (me._resizeTimeout);
				me._resizeTimeout = setTimeout (function () {
					me.onResize.apply (me);
				}, 1000);
			});
		};
		me.onResize = function () {
			owlCarouselContainer.trigger('destroy.owl.carousel');
			me.loadCarousels ();
		};
		me.loadCarousels = function () {
			if (owlCarouselContainer.children ().length > 1) {
				var options = {
					autoHeight: false,
					dots: true,
					items: 1,
					loop: false,
					nav: true,
					navText: ["<span></span>","<span></span>"]
				};
				if (owlCarouselContainer.hasClass ("hero-banner-items")) {
					options.autoplay = true;
					// options.autoplayHoverPause = true;
					options.autoplaySpeed = 1000;
					options.navSpeed = 1000;
					options.dotsSpeed = 1000;
					options.autoplayTimeout = 7000;
					options.loop = true;
				} else if (owlCarouselContainer.hasClass ("page-links-carousel")) {
					if (!owlCarouselContainer.parents (".HomePage").length && window.innerWidth > window.mobilePortraitPixelWidth) {
						options.items = 2;
						options.margin = 40;
					}
				}
				owlCarouselContainer.owlCarousel (options);
			} else {
				owlCarouselContainer.show ();
			}
		}
		me.init ();
	};
}) (window);
